// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picture-element{display:inline-block}.picture-element .provider-icon.square{border-radius:20%;height:50px;width:50px;min-width:50px;aspect-ratio:1}.picture-element .provider-icon.square.icon{min-width:50px}.picture-element .provider-icon.square.small{width:24px;height:24px;border-radius:4px;min-width:24px}.picture-element .provider-icon.wide{border-radius:8px;height:32px;width:80px;aspect-ratio:80/32;min-width:80px;min-height:32px}", ""]);
// Exports
module.exports = exports;
